import React from "react";
import powerOfEmailMark from "../../assets/images/prospecting-search/power-of-email-marketing.png";

const EmailPower = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-white" id="email-power">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-12 tw-items-center">
          
          {/* Text Column */}
          <div className="lg:tw-col-span-7 tw-text-left">
            <h2 className="tw-text-3xl sm:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-6">
              Unlock the Power of Email Marketing
            </h2>
            <p className="tw-text-base sm:tw-text-lg tw-text-slate-600 tw-leading-relaxed tw-mb-8">
              Our integrated email marketing tool works hand-in-hand with the prospecting search feature to simplify your outreach efforts. Whether it’s personalized drip campaigns or large-scale email blasts, you’ll have everything you need to nurture leads and close deals.
            </p>

            <h4 className="tw-text-sm tw-font-bold tw-text-slate-800 tw-uppercase tw-tracking-wider tw-mb-4">
              Additional Features Include:
            </h4>

            {/* Checklist */}
            <ul className="tw-space-y-4 tw-pl-0">
              <li className="tw-flex tw-items-start tw-gap-3 tw-text-base tw-text-slate-600">
                <span className="tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-full tw-bg-indigo-50 tw-text-[#5D44FF] tw-mt-0.5 tw-flex-shrink-0">
                  <svg className="tw-w-3.5 tw-h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
                  </svg>
                </span>
                <span>Drag-and-drop email builder for quick campaign creation.</span>
              </li>
              <li className="tw-flex tw-items-start tw-gap-3 tw-text-base tw-text-slate-600">
                <span className="tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-full tw-bg-indigo-50 tw-text-[#5D44FF] tw-mt-0.5 tw-flex-shrink-0">
                  <svg className="tw-w-3.5 tw-h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
                  </svg>
                </span>
                <span>A/B testing for subject lines and content optimization.</span>
              </li>
              <li className="tw-flex tw-items-start tw-gap-3 tw-text-base tw-text-slate-600">
                <span className="tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-full tw-bg-indigo-50 tw-text-[#5D44FF] tw-mt-0.5 tw-flex-shrink-0">
                  <svg className="tw-w-3.5 tw-h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
                  </svg>
                </span>
                <span>Dynamic content personalization for higher engagement rates.</span>
              </li>
              <li className="tw-flex tw-items-start tw-gap-3 tw-text-base tw-text-slate-600">
                <span className="tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-full tw-bg-indigo-50 tw-text-[#5D44FF] tw-mt-0.5 tw-flex-shrink-0">
                  <svg className="tw-w-3.5 tw-h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
                  </svg>
                </span>
                <span>GDPR-compliant tools to ensure data privacy.</span>
              </li>
            </ul>
          </div>

          {/* Image Column */}
          <div className="lg:tw-col-span-5 tw-text-center">
            <img
              src={powerOfEmailMark}
              alt="Email Marketing Tools"
              className="tw-w-full tw-h-auto tw-max-h-[380px] tw-object-contain hover:tw-scale-[1.01] tw-transition-transform tw-duration-300"
              loading="lazy"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default EmailPower;
